import { TAROT_CARDS } from "../data/tarotCards";

const STORAGE_KEY = "tripcanvas_daily_cards"; // { "uid_YYYY-MM-DD": cardId }

// 간단한 문자열 해시 (32-bit)
function hashString(str) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i);
    hash = hash & hash;
  }
  return Math.abs(hash);
}

// 오늘 날짜 (YYYY-MM-DD, 로컬 기준)
export function todayStr(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

// 오늘의 카드 1장 결정 — uid + 날짜로 시드 고정 → 같은 날 동일 카드
export function getDailyCard({ uid = "guest", mbti = "", zodiac = "" } = {}) {
  const date = todayStr();
  const seed = hashString(`${uid}-${date}`);

  // 60% 확률로 사용자 성향과 어울리는 카드 풀에서 뽑음
  const useAffinity = (seed % 100) < 60 && (mbti || zodiac);
  const zodiacKey = zodiac ? zodiac.split(" ")[0] : "";

  let pool = TAROT_CARDS;
  if (useAffinity) {
    const affinityPool = TAROT_CARDS.filter(c =>
      (mbti && c.affinityMBTI?.includes(mbti)) ||
      (zodiacKey && c.affinityZodiac?.includes(zodiacKey))
    );
    if (affinityPool.length > 0) pool = affinityPool;
  }

  const card = pool[seed % pool.length];
  return { ...card, drawDate: date };
}

// 오늘 카드를 컬렉션에 저장
export function saveCardToCollection(uid, card) {
  if (!card) return;
  try {
    const raw = localStorage.getItem(STORAGE_KEY) || "{}";
    const data = JSON.parse(raw);
    const key = `${uid || "guest"}_${card.drawDate || todayStr()}`;
    if (!data[key]) {
      data[key] = card.id;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    }
  } catch (e) {}
}

// 사용자가 받은 모든 카드 (중복 제거 + 최신 순)
export function getUserCollection(uid) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY) || "{}";
    const data = JSON.parse(raw);
    const prefix = `${uid || "guest"}_`;
    const entries = Object.entries(data)
      .filter(([k]) => k.startsWith(prefix))
      .map(([k, cardId]) => ({ date: k.slice(prefix.length), cardId }))
      .sort((a, b) => b.date.localeCompare(a.date));

    // 카드 ID별로 최초 획득일 기록
    const cardMap = new Map();
    entries.forEach(e => {
      if (!cardMap.has(e.cardId)) cardMap.set(e.cardId, e.date);
    });

    return Array.from(cardMap.entries()).map(([cardId, date]) => ({
      card: TAROT_CARDS.find(c => c.id === cardId),
      firstDate: date,
    })).filter(x => x.card);
  } catch (e) {
    return [];
  }
}

// 메시지에서 {name} 치환
export function personalizeMessage(message, name) {
  return message.replace(/\{name\}/g, name || "여행자");
}
